<template>
    <TableLayout :permissions="['business:deviceevent:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="姓名/手机号" prop="keyWords">
                <el-input v-model="searchForm.keyWords" placeholder="请输入姓名/手机号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="公司/组织名称" prop="companyName">
                <el-input v-model="searchForm.companyName" placeholder="请输入公司/组织名称" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="人员类型" prop="personType">
                <el-select v-model="searchForm.personType" placeholder="请选择">
                    <el-option label="外来访客" value="1"></el-option>
                    <el-option label="内部人员" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="事件类型" prop="eventType">
                <el-select v-model="searchForm.eventType" placeholder="请选择">
                    <el-option label="人脸认证失败" value="197163"></el-option>
                    <el-option label="人脸认证通过" value="196893"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="起始时间" prop="eventType">
                <el-date-picker
                    @change="seleTime"
                    v-model="time"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-radio-group v-model="searchForm.radio" size="small" @input="changeRadio">
                <el-radio-button label="0">当天</el-radio-button>
                <el-radio-button label="1">近7天</el-radio-button>
                <el-radio-button label="2">近30天</el-radio-button>
            </el-radio-group>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['business:deviceevent:exportExcel']">
<!--
                <li><el-button type="primary" :loading="isWorking.export" v-permissions="['business:deviceevent:exportExcel']" @click="exportExcel">导出</el-button></li>
-->
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
            >
                <el-table-column prop="userType" label="人员类型" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.personType == 0">劳务访客</span>
                        <span v-if="row.personType == 1">普通访客</span>
                        <span v-if="row.personType == 2">内部人员</span>
                        <span v-if="row.personType == null">外来访客</span>
                    </template>
                </el-table-column>
              <el-table-column prop="happenTime" label="事件时间" min-width="100px"></el-table-column>
                <el-table-column prop="devName" label="门禁名称" min-width="100px"></el-table-column>
                <el-table-column prop="srcName" label="门禁点" min-width="100px"></el-table-column>
                <el-table-column prop="eventTypeName" label="事件类型" min-width="100px"></el-table-column>
                <el-table-column label="出入类型" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.extEventInOut === 1">进</span>
                        <span v-if="row.extEventInOut != 1">出</span>
                    </template>
                </el-table-column>
                <el-table-column label="抓拍照片" min-width="100px">
                    <template slot-scope="{row}">
                        <el-image
                            style="width: 80px; height: 80px"
                            :src="row.extEventPictureURL"
                            :preview-src-list="[row.extEventPictureURL]">
                        </el-image>
                    </template>
                </el-table-column>

              <el-table-column prop="personName" label="姓名" min-width="100px"></el-table-column>
              <el-table-column prop="personPhone" label="手机号" min-width="100px"></el-table-column>
              <el-table-column prop="personIdcardDecode" label="证件号" min-width="100px"></el-table-column>
              <el-table-column prop="personCompanyName" label="公司/组织" min-width="100px"></el-table-column>

            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import { timeForMat } from '@/utils/util'
export default {
  name: 'DeviceEvent',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        keyWords: '',
        companyName: '',
        personType: '',
        eventType: '',
        startTime: '',
        endTime: '',
        radio: 0
      },
      time: []
    }
  },
  created () {
    this.config({
      module: '门禁事件推送记录表',
      api: '/business/deviceEvent',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.changeRadio('0')
    this.search()
  },
  methods: {
    changeRadio (e) {
      if (e === '0') {
        this.searchForm.startTime = timeForMat(0)[0]
        this.searchForm.endTime = timeForMat(0)[1]
        this.time = timeForMat(0)
      } else if (e === '1') {
        this.searchForm.startTime = timeForMat(6)[0]
        this.searchForm.endTime = timeForMat(6)[1]
        this.time = timeForMat(6)
      } else if (e === '2') {
        this.searchForm.startTime = timeForMat(29)[0]
        this.searchForm.endTime = timeForMat(29)[1]
        this.time = timeForMat(29)
      }
      this.search()
    },
    seleTime (e) {
      this.searchForm.startTime = e[0]
      this.searchForm.endTime = e[1]
      this.searchForm.radio = null
      this.search()
    },
    reset () {
      this.$refs.searchForm.resetFields()
      this.time = []
      this.searchForm.radio = '0'
      this.changeRadio('0')
      this.search()
    }
  }
}
</script>
